import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'react-router-redux';
import { store, browserHistory } from './redux/config';
import { Fetch } from '@fyresite/fetch';

import 'font-awesome/css/font-awesome.css';
import './index.scss';

import Home from './containers/Home'
import Dashboard from './containers/Dashboard'
import { userIsAuthenticated } from './auth.js'


Fetch.updateConfig({
  localhost: "localhost:3000",
  "34.214.125.224": "34.214.125.224"
})

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={browserHistory}>
      <Switch>
        <Route path='/dashboard' component={userIsAuthenticated(Dashboard)}/>
        <Route path='/' component={Home} />
      </Switch>
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js